export default "__VITE_ASSET__Bn2Vi11w__"